export default "__VITE_ASSET__Db2xUqeS__"